"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const encoding_1 = require("@iov/encoding");
const abi_1 = require("./../abi");
var SwapContractEvent;
(function (SwapContractEvent) {
    SwapContractEvent[SwapContractEvent["Opened"] = 0] = "Opened";
    SwapContractEvent[SwapContractEvent["Claimed"] = 1] = "Claimed";
    SwapContractEvent[SwapContractEvent["Aborted"] = 2] = "Aborted";
})(SwapContractEvent = exports.SwapContractEvent || (exports.SwapContractEvent = {}));
var SwapContractMethod;
(function (SwapContractMethod) {
    SwapContractMethod[SwapContractMethod["Open"] = 0] = "Open";
    SwapContractMethod[SwapContractMethod["Claim"] = 1] = "Claim";
    SwapContractMethod[SwapContractMethod["Abort"] = 2] = "Abort";
})(SwapContractMethod = exports.SwapContractMethod || (exports.SwapContractMethod = {}));
class AtomicSwapContract {
    // ABI methods previously decodeSwapProcessState in ABI file
    static abiDecodeSwapProcessState(data) {
        if (data.length !== 32) {
            throw new Error("Input data not 256 bit long");
        }
        const key = abi_1.Abi.decodeUint256(data);
        const map = {
            1: bcp_1.SwapProcessState.Open,
            2: bcp_1.SwapProcessState.Claimed,
            3: bcp_1.SwapProcessState.Aborted,
        };
        const state = map[key];
        if (state === undefined) {
            throw new Error("Invalid swap process state");
        }
        return state;
    }
    // ABI methods previously decodeMethodId in ABI file
    static abiDecodeMethodId(data) {
        if (data.length !== 4) {
            throw new Error("Input data not 32 bit long");
        }
        const key = encoding_1.toHex(data);
        const map = {
            [AtomicSwapContract.abiMethodIds.openEth]: SwapContractMethod.Open,
            [AtomicSwapContract.abiMethodIds.openErc20]: SwapContractMethod.Open,
            [AtomicSwapContract.abiMethodIds.claim]: SwapContractMethod.Claim,
            [AtomicSwapContract.abiMethodIds.abort]: SwapContractMethod.Abort,
        };
        const method = map[key];
        if (method === undefined) {
            throw new Error("Invalid method ID");
        }
        return method;
    }
    // ABI methods previously decodeEventSignature in ABI file
    static abiDecodeEventSignature(data) {
        if (data.length !== 32) {
            throw new Error("Input data not 256 bit long");
        }
        const key = encoding_1.toHex(data);
        const map = {
            [AtomicSwapContract.abiEventSignatures.openedEth]: SwapContractEvent.Opened,
            [AtomicSwapContract.abiEventSignatures.openedErc20]: SwapContractEvent.Opened,
            [AtomicSwapContract.abiEventSignatures.claimed]: SwapContractEvent.Claimed,
            [AtomicSwapContract.abiEventSignatures.aborted]: SwapContractEvent.Aborted,
        };
        const event = map[key];
        if (event === undefined) {
            throw new Error("Invalid event signature");
        }
        return event;
    }
}
exports.AtomicSwapContract = AtomicSwapContract;
// ABI methods previously eventSignatures in ABI file
AtomicSwapContract.abiEventSignatures = {
    openedEth: encoding_1.toHex(abi_1.Abi.calculateMethodHash("Opened(bytes32,address,address,bytes32,uint256,uint256)")),
    openedErc20: encoding_1.toHex(abi_1.Abi.calculateMethodHash("Opened(bytes32,address,address,bytes32,uint256,uint256,address)")),
    claimed: encoding_1.toHex(abi_1.Abi.calculateMethodHash("Claimed(bytes32,bytes32)")),
    aborted: encoding_1.toHex(abi_1.Abi.calculateMethodHash("Aborted(bytes32)")),
};
// ABI methods previously methodIds in ABI file
AtomicSwapContract.abiMethodIds = {
    openEth: encoding_1.toHex(abi_1.Abi.calculateMethodId("open(bytes32,address,bytes32,uint256)")),
    openErc20: encoding_1.toHex(abi_1.Abi.calculateMethodId("open(bytes32,address,bytes32,uint256,address,uint256)")),
    claim: encoding_1.toHex(abi_1.Abi.calculateMethodId("claim(bytes32,bytes32)")),
    abort: encoding_1.toHex(abi_1.Abi.calculateMethodId("abort(bytes32)")),
};
//# sourceMappingURL=atomicswapcontract.js.map